import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import { Box } from 'approot/shared/styles/box.style';
import { PrimaryLinkButton } from 'approot/shared/styles/buttons/link-button.style';
import {
  SecondaryButton,
  SecondaryButtonLink,
} from 'approot/shared/styles/buttons/secondary-button.style';
import { grey10, grey3 } from 'approot/shared/styles/colours.style';
import {
  spacing12,
  spacing16,
  spacing24,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import {
  font12,
  font14,
  fontWeightBold,
  LinkStyled,
} from 'approot/shared/styles/typography.style';
import {
  LAYOUT_DRAWER_FOOTER_HEIGHT,
  LAYOUT_HEADER_HEIGHT,
} from '../../layout.styles';
import {
  NavigationDrawer,
  navigationBaseLinkCss,
} from '../shared/navigation-shared.style';

type MiniNavProps = {
  bannerHeight: number;
};

export const MiniNav = styled(NavigationDrawer)<MiniNavProps>`
  max-width: none;
  width: 100%;
  top: ${({ bannerHeight }) => rem(bannerHeight)};
`;

export const MiniNavHeading = styled.h2`
  ${font12}
  color: ${grey10};
  font-weight: ${fontWeightBold};
  margin-bottom: ${rem(spacing8)};
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const MiniNavCloseButton = styled(SecondaryButton)`
  position: absolute;
  top: ${rem(spacing12)};
  left: ${rem(spacing16)};
`;

export const MiniNavLinksWrapper = styled.div`
  padding: 0 ${rem(spacing16)};

  ${MiniNavHeading} {
    padding-left: ${rem(spacing8)};
    padding-right: ${rem(spacing8)};
  }
`;

export const MiniNavScrollContainer = styled.div`
  padding: ${rem(spacing16)} 0 0;
  position: absolute;
  top: ${rem(LAYOUT_HEADER_HEIGHT)};
  bottom: ${rem(LAYOUT_DRAWER_FOOTER_HEIGHT)};
  left: 0;
  right: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const baseMiniNavLinkCss = css`
  ${navigationBaseLinkCss}
  ${font14}
  padding: ${rem(6)} 0 ${rem(6)}  ${rem(spacing8)};
  flex: 0 0 50%;
  align-items: flex-start;
  text-align: left;
`;

export const MiniNavLink = styled(Link)`
  ${baseMiniNavLinkCss}
`;

export const MiniNavButton = styled(PrimaryLinkButton)`
  ${baseMiniNavLinkCss}
`;

export const MiniNavAnchor = styled.a`
  ${baseMiniNavLinkCss}
`;

export const MiniNavHeader = styled.div`
  height: ${rem(LAYOUT_HEADER_HEIGHT)};
  border-bottom: 1px solid ${grey3};
`;

export const MiniNavFooter = styled(Box).attrs({
  $gap: 16,
  $flexDirection: 'column',
})`
  padding: ${rem(spacing24)} ${rem(spacing16)};
  position: fixed;
  bottom: 0;
  width: 100%;

  ${SecondaryButtonLink} {
    flex: 1;
  }
`;

export const MiniNavViewAll = styled(LinkStyled)`
  ${font14}
  color: ${grey10};
`;
